// ── Color helpers (respect --no-color / NO_COLOR) ──

function colorEnabled(): boolean {
  return process.stderr.isTTY === true && !process.env.NO_COLOR;
}

const ansi = {
  reset: '\x1b[0m',
  dim: '\x1b[2m',
  red: '\x1b[31m',
  green: '\x1b[32m',
  yellow: '\x1b[33m',
};

function c(code: keyof typeof ansi, text: string): string {
  if (!colorEnabled()) return text;
  return `${ansi[code]}${text}${ansi.reset}`;
}

// ── JSON mode detection ──

export function isJsonMode(options: { json?: boolean }): boolean {
  if (options.json) return true;
  return !process.stdout.isTTY;
}

export function printJson(data: unknown): void {
  process.stdout.write(JSON.stringify(data, null, 2) + '\n');
}

// ── Message helpers ──
// Every function uses a text prefix so status is conveyed independent of color.
// Color is enhancement only — never the sole status indicator.

/** General informational message (no prefix). */
export function info(msg: string): void {
  process.stderr.write(`${msg}\n`);
}

/** Success: confirms an outcome. Use after a completed action. */
export function success(msg: string): void {
  process.stderr.write(`${c('green', '\u2713')} ${msg}\n`);
}

/** Warning: something is off but not fatal. */
export function warn(msg: string): void {
  process.stderr.write(`${c('yellow', '\u26A0')} ${msg}\n`);
}

/** Error: state what failed, why, and what to do next. */
export function error(msg: string): void {
  process.stderr.write(`${c('red', '\u2717')} Error: ${msg}\n`);
}

/** Hint: suggest a next step or recovery action. Indented for readability. */
export function hint(msg: string): void {
  process.stderr.write(`${c('dim', '  ' + msg)}\n`);
}
